import { render, staticRenderFns } from "./DccTransactionsDetails.vue?vue&type=template&id=3e88f124&scoped=true"
import script from "./DccTransactionsDetails.vue?vue&type=script&lang=js"
export * from "./DccTransactionsDetails.vue?vue&type=script&lang=js"
import style0 from "./DccTransactionsDetails.vue?vue&type=style&index=0&id=3e88f124&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e88f124",
  null
  
)

export default component.exports